import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledArrow = styled(BaseSvg)`
  height: 1rem;
  width: 1rem;
  color: #8e8e8e;
`

const ArrowDownRight = ({ title = 'Arrow Down Right', ...rest }: IconProps) => (
  <StyledArrow viewBox="0 0 11 11" title={title} {...rest}>
    <g id="tab-nav" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="action_tabnav_8" transform="translate(-428.000000, -453.000000)" fill="#A0A0A0" fillRule="nonzero">
        <g id="features-and-sources" transform="translate(362.000000, 248.000000)">
          <g id="Features-Block" transform="translate(35.000000, 33.000000)">
            <g
              id="icon_arrow_right_round"
              transform="translate(36.499893, 177.495149) scale(1, -1) translate(-36.499893, -177.495149) translate(31.000000, 172.000000)"
            >
              <path
                d="M6.84118554,0.220558518 C6.53288914,-0.0772041097 6.04283657,-0.0729456853 5.73976129,0.230129597 C5.43668601,0.53320488 5.43242758,1.02325745 5.73019021,1.33155385 L8.31753648,3.91890012 L3.92855492,3.91890012 C1.75995084,3.92149778 0.00259765192,5.67885097 0,7.84745505 L0,10.204588 C0,10.6385242 0.35177479,10.990299 0.785710985,10.990299 C1.21964718,10.990299 1.57142197,10.6385242 1.57142197,10.204588 L1.57142197,7.84745505 C1.57142197,6.54564646 2.62674634,5.49032209 3.92855492,5.49032209 L8.31753648,5.49032209 L5.73019021,8.07766837 C5.52593947,8.27494033 5.44402437,8.56707037 5.51592906,8.84177805 C5.58783375,9.11648574 5.80236817,9.33102016 6.07707586,9.40292485 C6.35178354,9.47482954 6.64391357,9.39291444 6.84118554,9.1886637 L10.7697405,5.26010877 C11.0764678,4.95328875 11.0764678,4.45593346 10.7697405,4.14911344 L6.84118554,0.220558518 Z"
                id="Path"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </StyledArrow>
)

ArrowDownRight.needsWork = true
ArrowDownRight.displayName = 'ArrowDownRight'
export default ArrowDownRight
